'use client';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useFeatureToggle } from '.';
import { FT_PI_DISCOUNT_RATE, SEARCH_COMPANY_BY_ID, BOOKING_CHANNEL, SITE_LEISURE, GET_STATIC_CONTENT, Area } from '@whitbread-eos/api';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import useGetCountryLanguage from './use-get-country-language';
import { useHotelAvailabilityDiscountRate, useHotelRatesInformationDiscountRate } from './use-hotel-availability';
import { useQueryRequest } from './use-request';
export function getRatePlanCode(offers, targetCorpId) {
  var offer = offers === null || offers === void 0 ? void 0 : offers.find(offer => (offer === null || offer === void 0 ? void 0 : offer.corpId) === targetCorpId);
  return offer === null || offer === void 0 ? void 0 : offer.ratePlanCode;
}
export var getCorporateDiscountRatePlanCode = ratePlans => {
  var planWithDiscount = ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.find(plan => (plan === null || plan === void 0 ? void 0 : plan.isCorporateDiscountAvailable) === true);
  return planWithDiscount ? planWithDiscount === null || planWithDiscount === void 0 ? void 0 : planWithDiscount.ratePlanCode : '';
};
export function updateRateInfoWithCorporateDiscount(dataHotelInformations, companyData, ratePlanCode) {
  var _dataHotelInformation;
  dataHotelInformations === null || dataHotelInformations === void 0 || (_dataHotelInformation = dataHotelInformations.ratesInformation) === null || _dataHotelInformation === void 0 || (_dataHotelInformation = _dataHotelInformation.rateClassifications) === null || _dataHotelInformation === void 0 || _dataHotelInformation.forEach(rateInfo => {
    if ((rateInfo === null || rateInfo === void 0 ? void 0 : rateInfo.ratePlanCode) === ratePlanCode) {
      var _companyData$companyP, _companyData$companyP2;
      rateInfo.rateName = (_companyData$companyP = companyData === null || companyData === void 0 || (_companyData$companyP2 = companyData.companyProfile) === null || _companyData$companyP2 === void 0 ? void 0 : _companyData$companyP2.name) !== null && _companyData$companyP !== void 0 ? _companyData$companyP : '';
      rateInfo.isCorporateDiscountAvailable = true;
    }
  });
}
export function useForDiscountedRateFlag() {
  var _useFeatureToggle = useFeatureToggle(),
    isDiscountRateEnabled = _useFeatureToggle[FT_PI_DISCOUNT_RATE];
  return !!isDiscountRateEnabled;
}
export function useForDiscountedRateMicroSite() {
  var _useRouter = useRouter(),
    CORPID = _useRouter.query.CORPID;
  return useForDiscountedRateFlag() && !!CORPID;
}
export function useDiscountRateInfoHotelAvailability(_ref) {
  var _companyData$companyP3;
  var hotelId = _ref.hotelId,
    hotelBrand = _ref.hotelBrand,
    arrival = _ref.arrival,
    departure = _ref.departure,
    rooms = _ref.rooms,
    offers = _ref.offers;
  var _useRouter2 = useRouter(),
    CORPID = _useRouter2.query.CORPID;
  var isDiscountRateEnabled = useForDiscountedRateMicroSite();
  var _useQueryRequest = useQueryRequest(['searchCompanyById', CORPID], SEARCH_COMPANY_BY_ID, {
      corpId: CORPID
    }, {
      enabled: !!CORPID && isDiscountRateEnabled,
      retry: false
    }, undefined, true),
    isLoadingCompanyData = _useQueryRequest.isLoading,
    isErrorCompanyData = _useQueryRequest.isError,
    companyData = _useQueryRequest.data;
  var hotelAvailabilityQueryEnabled = !!(companyData && !isLoadingCompanyData);
  var _useHotelAvailability = useHotelAvailabilityDiscountRate({
      hotelId,
      hotelBrand,
      arrival,
      departure,
      rooms,
      channel: BOOKING_CHANNEL.PI,
      queryEnabled: hotelAvailabilityQueryEnabled,
      companyId: companyData === null || companyData === void 0 || (_companyData$companyP3 = companyData.companyProfile) === null || _companyData$companyP3 === void 0 ? void 0 : _companyData$companyP3.companyId
    }),
    isLoadingHotelAvailabilities = _useHotelAvailability.isLoading,
    isErrorHotelAvailabilities = _useHotelAvailability.isError,
    dataHotelAvailabilityData = _useHotelAvailability.data,
    errorHotelAvailabilities = _useHotelAvailability.error;
  var rateInformationQueryEnabled = !isErrorHotelAvailabilities && !errorHotelAvailabilities && !isLoadingHotelAvailabilities && !!dataHotelAvailabilityData;
  var _useHotelRatesInforma = useHotelRatesInformationDiscountRate(hotelId, hotelBrand, dataHotelAvailabilityData, BOOKING_CHANNEL.PI, rateInformationQueryEnabled),
    isLoadingHotelInformations = _useHotelRatesInforma.isLoading,
    isErrorHotelInformations = _useHotelRatesInforma.isError,
    dataHotelRateInformations = _useHotelRatesInforma.data,
    errorHotelInformations = _useHotelRatesInforma.error;
  var ratePlanCode = getRatePlanCode(offers, CORPID);
  updateRateInfoWithCorporateDiscount(dataHotelRateInformations, companyData, ratePlanCode);
  var dataHotelAvailability = dataHotelAvailabilityData;
  var hotelAvailabilityResponse = {
    isLoadingHotelAvailability: isLoadingHotelInformations || isLoadingHotelAvailabilities,
    isErrorHotelAvailability: isErrorHotelInformations || isErrorHotelAvailabilities,
    dataHotelAvailability: dataHotelRateInformations && dataHotelAvailability && _objectSpread(_objectSpread({}, dataHotelRateInformations), dataHotelAvailability),
    errorHotelAvailability: errorHotelInformations || errorHotelAvailabilities
  };
  return {
    hotelAvailabilityResponse,
    dataHotelAvailability,
    isDiscountRateLoading: isLoadingHotelInformations || isLoadingCompanyData || isLoadingHotelAvailabilities,
    isDiscountRateError: isErrorHotelInformations || isErrorCompanyData || isErrorHotelAvailabilities
  };
}
export function useUpdateRateName(bookingData, language, country) {
  var _dataHeaderInformatio;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var HDPPath = '';
  if (typeof window !== 'undefined') HDPPath = localStorage.getItem('HDPPath');
  var urlParams = new URLSearchParams(HDPPath);
  var _useQueryRequest2 = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      language,
      country,
      site: SITE_LEISURE,
      businessBooker: false
    }),
    dataHeaderInformation = _useQueryRequest2.data;
  var offer = dataHeaderInformation === null || dataHeaderInformation === void 0 || (_dataHeaderInformatio = dataHeaderInformation.headerInformation) === null || _dataHeaderInformatio === void 0 || (_dataHeaderInformatio = _dataHeaderInformatio.content) === null || _dataHeaderInformatio === void 0 || (_dataHeaderInformatio = _dataHeaderInformatio.global) === null || _dataHeaderInformatio === void 0 ? void 0 : _dataHeaderInformatio.offers;
  var isDiscountRateEnabled = useForDiscountedRateFlag();
  var CORPID = urlParams.get('CORPID');
  if (!CORPID || !offer) return;
  var ratePlanCodes = getRatePlanCode(offer, CORPID);
  if (isDiscountRateEnabled) bookingData.reservationByIdList.forEach(reservation => {
    if (reservation.roomStay.ratePlanCode === ratePlanCodes) {
      var _bookingData$upgradeT;
      if (bookingData !== null && bookingData !== void 0 && (_bookingData$upgradeT = bookingData.upgradeToFlex) !== null && _bookingData$upgradeT !== void 0 && _bookingData$upgradeT.flexRateCode) {
        bookingData.upgradeToFlex.flexRateCode = '';
      }
      reservation.roomStay.rateExtraInfo.rateName = t("promotion.discountrate.".concat(ratePlanCodes, ".ratename"));
    }
  });
}
export function getMatchedOffer(offersConfigData, targetRatePlanCode) {
  return targetRatePlanCode ? offersConfigData === null || offersConfigData === void 0 ? void 0 : offersConfigData.find(offer => (offer === null || offer === void 0 ? void 0 : offer.ratePlanCode) === targetRatePlanCode) : null;
}
export function useGetDiscountRateComapnyId(hotelAvailabilityParams) {
  var _headerInformationDat, _hotelAvailabilityPar;
  var comapanyId = '';
  var isDiscountRateFeatureEnabled = useForDiscountedRateFlag();
  var _useGetCountryLanguag = useGetCountryLanguage(),
    language = _useGetCountryLanguag.language,
    country = _useGetCountryLanguag.country;
  var _useQueryRequest3 = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      language,
      country,
      site: SITE_LEISURE,
      businessBooker: false,
      enabled: isDiscountRateFeatureEnabled
    }),
    headerInformationData = _useQueryRequest3.data;
  var matchedOffer = getMatchedOffer(headerInformationData === null || headerInformationData === void 0 || (_headerInformationDat = headerInformationData.headerInformation) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.content) === null || _headerInformationDat === void 0 || (_headerInformationDat = _headerInformationDat.global) === null || _headerInformationDat === void 0 ? void 0 : _headerInformationDat.offers, hotelAvailabilityParams === null || hotelAvailabilityParams === void 0 ? void 0 : hotelAvailabilityParams.rateCode);
  var corpId = matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.corpId;
  var companyIdQueryEnabled = isDiscountRateFeatureEnabled && (hotelAvailabilityParams === null || hotelAvailabilityParams === void 0 || (_hotelAvailabilityPar = hotelAvailabilityParams.channel) === null || _hotelAvailabilityPar === void 0 ? void 0 : _hotelAvailabilityPar.toLowerCase()) === Area.PI.toLowerCase() && !!headerInformationData && !!corpId;
  var _useQueryRequest4 = useQueryRequest(['searchCompanyById', corpId], SEARCH_COMPANY_BY_ID, {
      corpId: corpId
    }, {
      enabled: !!corpId && companyIdQueryEnabled,
      retry: false
    }, undefined, true),
    isLoadingCompanyData = _useQueryRequest4.isLoading,
    isErrorCompanyData = _useQueryRequest4.isError,
    companyData = _useQueryRequest4.data;
  if (!!companyData && !isLoadingCompanyData && !isErrorCompanyData && companyIdQueryEnabled) {
    var _companyData$companyP4;
    comapanyId = companyData === null || companyData === void 0 || (_companyData$companyP4 = companyData.companyProfile) === null || _companyData$companyP4 === void 0 ? void 0 : _companyData$companyP4.companyId;
  }
  return comapanyId;
}
export function useGetDiscountRateReservationData(offersConfigData, bookingConfirmationData, variant) {
  var _bookingConfirmationD, _discountRateReservat;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var isDiscountRateFeatureEnabled = useForDiscountedRateFlag();
  if (!isDiscountRateFeatureEnabled) {
    return {
      isDiscountRate: false,
      maxRooms: 0,
      matchedDiscountRate: '',
      roomLimitMessage: '',
      unAvailableMessage: ''
    };
  }
  var discountRateReservation = bookingConfirmationData === null || bookingConfirmationData === void 0 || (_bookingConfirmationD = bookingConfirmationData.reservationByIdList) === null || _bookingConfirmationD === void 0 ? void 0 : _bookingConfirmationD.find(room => {
    return (offersConfigData === null || offersConfigData === void 0 ? void 0 : offersConfigData.some(offer => {
      var _room$roomStay;
      return (offer === null || offer === void 0 ? void 0 : offer.ratePlanCode) === (room === null || room === void 0 || (_room$roomStay = room.roomStay) === null || _room$roomStay === void 0 ? void 0 : _room$roomStay.ratePlanCode);
    })) && isDiscountRateFeatureEnabled && [Area.PI, Area.CCUI].includes(variant);
  });
  var matchedOffer = getMatchedOffer(offersConfigData, discountRateReservation === null || discountRateReservation === void 0 || (_discountRateReservat = discountRateReservation.roomStay) === null || _discountRateReservat === void 0 ? void 0 : _discountRateReservat.ratePlanCode);
  return discountRateReservation && matchedOffer ? {
    isDiscountRate: true,
    maxRooms: Number(matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.maxRooms) || 0,
    matchedDiscountRate: (matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.ratePlanCode) || '',
    roomLimitMessage: matchedOffer !== null && matchedOffer !== void 0 && matchedOffer.ratePlanCode ? t("promotion.discountrate.".concat(matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.ratePlanCode, ".roomlimit"), {
      maxRooms: matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.maxRooms
    }) : '',
    unAvailableMessage: matchedOffer !== null && matchedOffer !== void 0 && matchedOffer.ratePlanCode ? t("promotion.discountrate.".concat(matchedOffer === null || matchedOffer === void 0 ? void 0 : matchedOffer.ratePlanCode, ".unavailable")) : ''
  } : {
    isDiscountRate: false,
    maxRooms: 0,
    matchedDiscountRate: '',
    roomLimitMessage: '',
    unAvailableMessage: ''
  };
}